import React from 'react'
import { InfoCircle } from 'react-bootstrap-icons'

import T from 'utils/useLocalizer'


const Error = ({ title, message, minHeight }: { title?: string, message?: string, minHeight?: number }) => {
    const resources = {
        title: T('component.error.message'),
    }
    return (
        <div className='position-relative text-danger p-4'>
            <div className='text-center' style={{ minHeight: minHeight || 300 }}>
                <InfoCircle className='fs-3' size={32} />
                <div>
                    <h5 className='fs-5 text-muted fw-bold m-0 ms-3'>{title ? title : resources.title}</h5>
                    {message && <p className='fs-6 text-muted m-0 ms-3'>{message}</p>}
                </div>
            </div>
        </div>
    )
}

export default Error